<template>
  <CeramicsModal :data="modalData"></CeramicsModal>
</template>
<script>
import CeramicsModal from '@/components/ceramics/CeramicsModal'
import link from '@/core/mixins/link'

export default {
  name: 'search-info',
  components: {
    CeramicsModal
  },
  mixins: [link],
  data() {
    return {
      modalData: {}
    }
  },
  methods: {
    getCategory(category) {
      let breadcrumb = this.$store.getters['CategoriesStore/breadcrumb'](
        category
      )
      breadcrumb = breadcrumb[breadcrumb.length - 1]
      // console.log(breadcrumb) // eslint-disable-line no-console
      return breadcrumb
    },
    // 内容点击跳转
    listClickFn(data, type, keyWord) {
      if (data.type === 'panorama') {
        // let r = this.getCategory(data.category_id)
        // this.link(r, type)
        console.log(data) // eslint-disable-line no-console
        this.link(
          {
            type: 'link',
            link: '/panorama/h5',
            category: 'panorama',
            query: { pano_no: data.pano_no }
          },
          type
        )
      } else if (data.type === 'ceramic') {
        if (type === 'windowOpen' && keyWord) {
          sessionStorage.setItem('ceramicModalData', JSON.stringify(data))
          window.open(`/search/ceramic?keyWord=${keyWord}&windowOpen=${type}`)
        } else {
          this.$set(this, 'modalData', data)
        }
      } else {
        this.link(
          {
            type: 'info',
            link: '/info',
            category: data.category_id,
            id: data.id
          },
          type
        )
      }
    }
  }
}
</script>
